module.exports = __webpack_public_path__ + "static/media/article-morakot.afbbf2a6.png";